import { MapPin, Paintbrush, MessageCircle, Home, FileCheck, Phone, MessageSquare } from "lucide-react";
import ScrollReveal from "./ScrollReveal";

const trustPoints = [
  { icon: MapPin, label: "Locally owned and operated" },
  { icon: Paintbrush, label: "Focused on proper prep and clean finishes" },
  { icon: MessageCircle, label: "Clear communication from start to finish" },
  { icon: Home, label: "Respectful of your home and time" },
  { icon: FileCheck, label: "Free, honest estimates" },
];

const TrustSection = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <ScrollReveal>
            <div className="text-center mb-10">
              <h2 className="section-heading">Quality Work You Can Trust</h2>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <div className="space-y-6 text-lg text-muted-foreground leading-relaxed mb-12">
              <p>
                We're a locally owned flooring business focused on clean work, proper prep, and results that last. Every project is handled with care — from the first sanding pass to the final detail — because we know your floors are a big part of your home.
              </p>
              <p>
                We don't rush jobs or cut corners. We show up, communicate clearly, and treat every home with respect. Whether it's a full hardwood refinish or a new floor install, our goal is simple: do the job right and stand behind the work.
              </p>
            </div>
          </ScrollReveal>

          {/* Trust Points */}
          <ScrollReveal delay={0.2}>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
              {trustPoints.map((point, index) => (
                <div
                  key={index}
                  className="flex items-center gap-3 p-4 bg-card rounded-lg border border-border"
                >
                  <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center flex-shrink-0">
                    <point.icon className="w-5 h-5 text-accent" />
                  </div>
                  <span className="font-heading font-medium text-foreground">
                    {point.label}
                  </span>
                </div>
              ))}
            </div>
          </ScrollReveal>

          {/* Supporting Line */}
          <ScrollReveal delay={0.3}>
            <p className="text-center text-muted-foreground mb-10">
              Proudly serving local homeowners with professional flooring services they can rely on.
            </p>
          </ScrollReveal>

          {/* CTA */}
          <ScrollReveal delay={0.4}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+17192327424"
                className="btn-cta-primary flex items-center justify-center gap-3"
              >
                <Phone size={20} />
                Call for Free Estimate
              </a>
              <a
                href="sms:+17192327424"
                className="btn-cta-secondary flex items-center justify-center gap-3"
              >
                <MessageSquare size={20} />
                Text Us
              </a>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default TrustSection;